import {
    RaikoCustomSelect, raikoCustomSelectItemGenerator, RaikoGridOneColumn,
    RaikoGridThreeColumn,
    RaikoSectionContainer,
    RaikoSimpleInputOutlined, showServerErrorMessage, showSuccessMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import RaikoBaseDialogContentContainer
    from "../../../raikoComponents/raikoBaseDialogContentContainer/RaikoBaseDialogContentContainer";
import {TourismCategoryService} from "../../../serverService/tourism/TourismCategoryService";
import {LoadingHelper} from "../../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../../context/LoadingContext";

export default function TourismCategoryDetail(
    {
        categoryId = -1,
        parentItems = [],
        handleCloseDialog,
        selectedLanguage
    }) {

    const service = new TourismCategoryService()
    const loading = new LoadingHelper(useLoadingDispatcher())

    const [name, setName] = useState("")
    const [slug, setSlug] = useState("")
    const [selectedParent, setSelectedParent] = useState(-1)
    const [formLoading, setFormLoading] = useState(false)

    useEffect(() => {
        if (categoryId && categoryId !== -1) {
            loading.show()
            service.getCategoryDetail(categoryId, selectedLanguage)
                .then(response => {
                    setName(response && response.metaData && response.metaData.title ? response.metaData.title : "")
                    setSlug(response.slug)
                    setSelectedParent(response && response.parent ? response.parent.id : -1)
                }).catch(reason => {
                showServerErrorMessage(reason)
            }).finally(() => {
                loading.hide()
            })
        }
    }, [categoryId]);


    function handleCreateNewCategory() {
        setFormLoading(true)
        service.addNewCategory(name, slug, selectedParent)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setFormLoading(false)
        })
    }

    function handleUpdateCategory() {
        setFormLoading(true)
        service.updateCategoryInfo(categoryId, selectedLanguage, name, slug, selectedParent)
            .then(response => {
                showSuccessMessage("بروزرسانی با موفقیت انجام شد.")
            }).catch(reason => {
            showServerErrorMessage(reason)
        }).finally(_ => {
            setFormLoading(false)
        })
    }

    return <RaikoBaseDialogContentContainer>
        <RaikoSectionContainer
            title={categoryId === -1 ? "افزودن دسته بندی" : "ویرایش دسته بندی"}
            hasActionButton
            actionButtonTitle={categoryId === -1 ? "افزودن" : "بروزرسانی"}
            actionButtonOnclickWithValidation={categoryId === -1 ? handleCreateNewCategory : handleUpdateCategory}
            actionButtonLoadingState={formLoading}
            hasSecondaryButton
            secondaryButtonTitle={"بازگشت"}
            secondaryButtonOnClick={handleCloseDialog}
        >
            <RaikoGridOneColumn>
                <RaikoSimpleInputOutlined
                    labelText={"عنوان"}
                    value={name}
                    setValue={setName}
                    required
                />
                <RaikoSimpleInputOutlined
                    labelText={"SLUG"}
                    value={slug}
                    setValue={setSlug}
                    required
                />
                <RaikoCustomSelect
                    labelText={"پدر"}
                    items={[
                        raikoCustomSelectItemGenerator(-1, "(دسته بندی اصلی)"),
                        ...parentItems
                    ]} value={selectedParent}
                    setValue={setSelectedParent}
                />
            </RaikoGridOneColumn>
        </RaikoSectionContainer>
    </RaikoBaseDialogContentContainer>
}